import { Controller } from '@hotwired/stimulus'
import './accordion_item_component.scss'

export default class extends Controller {
  static values = {
    expanded: Boolean,
  }

  connect() {
    this.bodyEl = this.element.querySelector('.js-accordion-item-body')
    this.iconEl = this.element.querySelector('.js-accordion-icon')

    if (this.bodyEl) {
      if (this.expandedValue) {
        this.bodyEl.style.maxHeight = 'none'
        this.bodyEl.style.opacity = '1'
      } else {
        this.bodyEl.style.maxHeight = '0'
        this.bodyEl.style.opacity = '0'
      }
    }

    this.updateIcon()
  }

  toggle() {
    // Don't toggle in editor mode — items stay expanded for editing
    if (this.element.closest('.builder-editing')) return

    this.expandedValue = !this.expandedValue

    if (this.expandedValue) {
      this.open()
      // Notify parent accordion for single-open mode
      this.element.dispatchEvent(
        new CustomEvent('accordion-item:opened', { bubbles: true })
      )
    } else {
      this.closeBody()
    }
  }

  toggleSpace(event) {
    if (event.target.closest('[contenteditable]')) return
    event.preventDefault()
    this.toggle()
  }

  close() {
    if (!this.expandedValue) return
    this.expandedValue = false
    this.closeBody()
  }

  open() {
    if (!this.bodyEl) return

    this._cancelTransitionEnd()

    // Measure natural height
    this.bodyEl.style.maxHeight = 'none'
    const height = this.bodyEl.scrollHeight
    this.bodyEl.style.maxHeight = '0px'

    // Force reflow
    this.bodyEl.offsetHeight // eslint-disable-line no-unused-expressions

    this.bodyEl.style.maxHeight = `${height}px`
    this.bodyEl.style.opacity = '1'

    // After transition, remove max-height constraint and release overflow so content can grow
    this._onTransitionEnd = (event) => {
      if (event.propertyName !== 'max-height') return
      this.bodyEl.style.maxHeight = 'none'
      this.bodyEl.style.overflow = ''
      this.bodyEl.removeEventListener('transitionend', this._onTransitionEnd)
      this._onTransitionEnd = null
    }
    this.bodyEl.addEventListener('transitionend', this._onTransitionEnd)

    this.updateIcon()
  }

  closeBody() {
    if (!this.bodyEl) return

    this._cancelTransitionEnd()
    this.bodyEl.style.overflow = 'hidden'

    // Set explicit height first so transition works
    this.bodyEl.style.maxHeight = `${this.bodyEl.scrollHeight}px`
    this.bodyEl.offsetHeight // eslint-disable-line no-unused-expressions

    this.bodyEl.style.maxHeight = '0'
    this.bodyEl.style.opacity = '0'

    this.updateIcon()
  }

  _cancelTransitionEnd() {
    if (this._onTransitionEnd) {
      this.bodyEl.removeEventListener('transitionend', this._onTransitionEnd)
      this._onTransitionEnd = null
    }
  }

  updateIcon() {
    if (!this.iconEl) return

    const modifier = this.iconEl.classList.contains('accordion-icon-plus-minus')
      ? 'accordion-icon-plus-minus--expanded'
      : 'accordion-icon--expanded'
    this.iconEl.classList.toggle(modifier, this.expandedValue)
  }
}
